/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
import {FormBuilder} from "@angular/forms";
declare var alertify:any;
@Component({
  templateUrl:'./fanstvPlanEdit.html'
})

export class FanstvPlanEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private fileupload:FileUpload,
    private location:Location
  ){}

  private data:any={
    "code": "",
    "planNameEn": "",
    "planNameTc": ""
  }

  private planNameEn:string='<p></p>';
  private planNameTc:string='<p></p>';
  private id:number = 0;
  private isCreate:boolean=false;
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['code'];
    });
   this.getData();

  }

  private getData():void{
    this.HttpService.getData(API.contractPlan+'/'+this.id).then(res=>{
      this.data = res.data;
      this.planNameEn=this.data.planNameEn;
      this.planNameTc=this.data.planNameTc;

    })
  }

  private onReady(str:string):void{
    if(str=='en'){
      this.planNameEn = this.data.planNameEn;
    }else if(str=='tc'){
      this.planNameTc = this.data.planNameTc;
    }
  }
  private onChange(str:string):void{
    if(str=='en'){
      this.planNameEn = this.data.planNameEn;
    }else if(str=='tc'){
      this.planNameTc = this.data.planNameTc;
    }
  }
  private submit():void{
    this.HttpService.postData(API.contractPlan,{
      "code":this.data.code,
      "planNameEn": this.data.planNameEn,
      "planNameTc": this.data.planNameTc
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/film/fanstvPlanEdit.component.ts